import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ImpersonationState {
  impersonatedUserId: string | null;
  setImpersonatedUserId: (id: string | null) => void;
}

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      impersonatedUserId: null,
      setImpersonatedUserId: (id) => set({ impersonatedUserId: id }),
    }),
    {
      name: "impersonation-storage",
    },
  ),
);
